// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"ee57e986","453":"a206e4db"}[chunkId] + ".chunk.js";
};